import { FC } from 'react'

type Props = {
  counterName: string
}

const QueueNodePreferredCounterBadge: FC<Props> = ({ counterName }) => {
  return <div className="badge badge-primary">{counterName}</div>
}

export { QueueNodePreferredCounterBadge }
